import { useState } from 'react';
import { Link } from 'react-router-dom';

function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="w-full bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 shadow-sm">
      <div className="w-full px-3 sm:px-4 lg:px-6">
        <div className="flex items-center justify-between h-11 sm:h-12 md:h-14">
          {/* Left: Hamburger (mobile) + primary links */}
          <div className="flex items-center space-x-4 lg:space-x-6">
            {/* Mobile: hamburger */}
            <div className="md:hidden">
              <button
                aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={mobileOpen}
                aria-controls="mobile-menu"
                onClick={() => setMobileOpen((s) => !s)}
                className="p-1.5 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                {mobileOpen ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 6.707a1 1 0 011.414-1.414L12 10.586l5.293-5.293a1 1 0 011.414 1.414L13.414 12l5.293 5.293a1 1 0 01-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 01-1.414-1.414L10.586 12 5.293 6.707z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                )}
              </button>
            </div>

            <div className="hidden md:flex items-center space-x-6">
              <Link
                to="/categories"
                className="text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded"
              >
                Categories
              </Link>
              <Link
                to="/products"
                className="text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded"
              >
                Products
              </Link>
            </div>
          </div>

          {/* Right: Mobile menu content (empty for now, could add other actions) */}
          <div className="flex items-center">
            {/* Additional navbar actions can be added here if needed */}
          </div>
        </div>
      </div>

      {/* Mobile menu panel */}
      {mobileOpen && (
        <div id="mobile-menu" className="md:hidden">
          <div className="px-3 pt-1 pb-3 space-y-1 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
            <Link
              to="/categories"
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2 rounded text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              Categories
            </Link>
            <Link
              to="/products"
              onClick={() => setMobileOpen(false)}
              className="block px-3 py-2 rounded text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              Products
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}

export default NavBar;
